var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxEditsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-edit.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 12.7605L8.55975 12.7493L15.7838 5.59428C16.0673 5.31078 16.2233 4.93428 16.2233 4.53378C16.2233 4.13328 16.0673 3.75678 15.7838 3.47328L14.5942 2.28378C14.0272 1.71678 13.038 1.71978 12.4755 2.28153L5.25 9.43803V12.7605ZM13.5338 3.34428L14.7255 4.53153L13.5278 5.71803L12.3383 4.52928L13.5338 3.34428ZM6.75 10.0635L11.2725 5.58378L12.462 6.77328L7.94025 11.2515L6.75 11.2553V10.0635Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.75 15.75H14.25C15.0773 15.75 15.75 15.0773 15.75 14.25V7.749L14.25 9.249V14.25H6.1185C6.099 14.25 6.07875 14.2575 6.05925 14.2575C6.0345 14.2575 6.00975 14.2507 5.98425 14.25H3.75V3.75H8.88525L10.3853 2.25H3.75C2.92275 2.25 2.25 2.92275 2.25 3.75V14.25C2.25 15.0773 2.92275 15.75 3.75 15.75Z",
    fill: "#8D8D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxEditsvg);
export default __webpack_public_path__ + "static/media/bx-edit.svg.ece2a012e07a1900eed32af1af51b8f8.svg";
export { ForwardRef as ReactComponent };